import { Code, Text } from '@chakra-ui/react'
import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'

export const Route = createFileRoute('/_app/datacenter/explorer')({
  component: DatacenterExplorerPage,
})

function DatacenterExplorerPage() {
  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_SHARED_WS_ADDRESS}
      username={import.meta.env.VITE_WS_USERNAME}
      password={import.meta.env.VITE_WS_PASSWORD}
      rootName="DataCenters"
      topicFilters="DataCenters/#"
      clientIdPrefix="stories_uns_datacenter"
      pageTitle="Data Center UNS Explorer"
      pageSubtitle="Explore the Data Center Unified Namespace in real-time"
      withLevelIcons
      intro={
        <>
          <Text>
            The Data Center Unified Namespace organizes infrastructure monitoring data in a
            hierarchical structure, from enterprise level down to individual sensors and datapoints.
          </Text>
          <Text>
            In an MQTT-based UNS, this translates to topic paths like{' '}
            <Code>DataCenters/SiteA/CoolingZone1/CRAC_01/SupplyTemp</Code> enabling any system,
            whether DCIM, BMS, or alerting platform, to publish or subscribe to exactly the data it
            needs.
          </Text>
        </>
      }
    />
  )
}
